export default {
      id: "pomme-pain-usage",
      viewBox: "0 0 168 271.67",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#pomme-pain-usage",
      toString: function () {
        return this.url;
      }
    }